module.exports = __webpack_public_path__ + "img/logo.64205ca6.png";